import {
  GET_AI_SUGGESTION_DATA_POWER_POSITION_FAILURE,
  GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS,
  GET_POWER_POSITION,
  GET_POWER_POSITION_FAILURE,
  GET_POWER_POSITION_LIST_FAILURE,
  GET_POWER_POSITION_LIST_SUCCESS,
  GET_POWER_POSITION_SUCCESS,
  RESET_POWER_POSITION,
  SET_POWER_POSITION,
  SET_POWER_POSITION_ID,
} from "../Action/actionTypes";

interface PowerPositionState {
  powerPositionData: {
    supplierExistOrNot: string | boolean;
    supplierAwareness: string | boolean;
    supplierDependent: string | boolean;
  };
  powerPosition: string;
  aiPowerPositionData: any;
  aiApiError: string;
  loading: boolean;
  error: string;
  powerPositionId: string;
  powerPositionListData:object[]
}

const initialState: PowerPositionState = {
  powerPositionData: {
    supplierExistOrNot: "",
    supplierAwareness: "",
    supplierDependent: "",
  },
  powerPosition: "",
  aiPowerPositionData: {},
  aiApiError: "",
  loading: false,
  error: "",
  powerPositionId: "",
  powerPositionListData:[]
};

const PowerPostionReducer = (
  state: PowerPositionState = initialState,
  action: any
): PowerPositionState => {
  switch (action.type) {
    case GET_POWER_POSITION:
      return {
        ...state,
        loading: true,
      };

    case GET_POWER_POSITION_SUCCESS:
      return {
        ...state,
        powerPositionData: action.payload,
        loading: false,
      };

    case GET_POWER_POSITION_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SET_POWER_POSITION:
      return {
        ...state,
        loading: false,
        powerPosition: action.payload,
      };

    case GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS: {
      let isExist = [
        "Superior",
        "Dependent",
        "Independent",
        "Inferior",
        null,
      ].includes(action.payload?.powerPosition);
      return {
        ...state,
        aiPowerPositionData: action.payload,
        powerPosition: isExist
          ? action.payload.powerPosition
          : state.powerPosition,
      };
    }

    case GET_AI_SUGGESTION_DATA_POWER_POSITION_FAILURE:
      return {
        ...state,
        aiApiError: action.payload,
      };

    case RESET_POWER_POSITION:
      return {
        ...state,
        ...initialState,
      };

    case SET_POWER_POSITION_ID: return {
      ...state,
      powerPositionId: action.payload
    }

    case GET_POWER_POSITION_LIST_SUCCESS : return {
      ...state,
      powerPositionListData: action.payload
    }

     case GET_POWER_POSITION_LIST_FAILURE : return {
      ...state,
      powerPositionListData: []
    }

    default:
      return state;
  }
};

export default PowerPostionReducer;
